import { ApiError, NetworkError, newIdempotencyKey } from '../api/client'

// SheetKeys holds the idempotency keys of one open sheet that sells, takes a
// payment, completes or refunds (review 2026-10-14). Pressing the same button
// again in the same sheet — a retry after a lost answer, or a double tap —
// sends the same key, so the server replays the first answer instead of
// charging or selling twice. A different request (another method, another
// package) gets its own key, because the server refuses a key reused for a
// different request. Once the server has answered a request with an error,
// that key is done with and the next try gets a fresh one; after a network
// failure (no answer) or "still in progress" the same key is kept.
export class SheetKeys {
  private keys = new Map<string, string>()

  constructor(private readonly make: () => string = newIdempotencyKey) {}

  // key is the idempotency key for this request ("complete:cash",
  // "sell:pkg_1:card"…) within this sheet.
  key(request: string): string {
    let key = this.keys.get(request)
    if (!key) {
      key = this.make()
      this.keys.set(request, key)
    }
    return key
  }

  // failed is told what went wrong with a request, and decides whether the
  // next attempt reuses its key.
  failed(request: string, error: unknown): void {
    if (error instanceof NetworkError) return
    if (error instanceof ApiError && error.problem === 'idempotency-key-in-progress') return
    this.keys.delete(request)
  }
}
